import styled from 'styled-components';

interface ProductStatusTextProps {
  subText?: string;
  text: string;
}

export const ProductStatusText = ({ subText, text }: ProductStatusTextProps) => {
  return (
    <Container>
      {subText && <Text>{subText}</Text>}
      <Text>{text}</Text>
    </Container>
  );
};

const Container = styled.div`
  position: absolute;

  left: 50%;
  top: 50%;
  display: flex;

  transform: translate(-50%, -50%);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const Text = styled.p`
  color: var(--light-scheme-monochrome-black, #232429);
  text-align: center;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 20.4px */
  mix-blend-mode: darken;
  opacity: 0.6;
  white-space: pre-line;
`;
